<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from 'vue-multiselect';
import Swal from '@/utils/ugm-swal';
import moment from "moment";
import DatePicker from "vue2-datepicker";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect, DatePicker },
    props: {
        eventoCodigo: {
            type: [String, Number],
            default: null
        },
        allowRedirect: {
            type: Boolean,
            default: true
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        tieneLaborantesAsignados() {
            return this.apoyo_pagado.length > 0 || this.relator_pagado.length > 0;
        }
    },
    data() {
        return {
            title: "Evento-Laborantes",
            items: [
                {
                text: "Eventos",
                href: "/"
                },
                {
                text: "Agregar Laborantes",
                active: true
                }
            ],
            evento:'',
            eventoid_seleccion:{},
            laborantes:[],
            status:'',
            apoyo:[
                {
                    laborante:[],
                    hora_inicio:'',
                    hora_fin:'',
                }
            ],
            relator:[
                {
                    laborante:'',
                    evento:'',
                    hora_inicio:'',
                    hora_fin:'',
                    fecha:'',
                    tipo:'Relator'
                }
            ],
            laborante:null,
            apoyo_pagado:[],
            relator_pagado:[],
            liquido:0,
            tipos:[],
            subtipos:[],
        };
    },
    watch:{
        eventoCodigo(nuevoCodigo, anteriorCodigo) {
            if (nuevoCodigo && nuevoCodigo !== anteriorCodigo) {
                this.cargarEvento(nuevoCodigo);
            }
        },
        readOnly: {
            handler(readOnly) {
                if (readOnly) {
                    this.apoyo = [];
                    this.relator = [];
                    this.status = '';
                }
            },
            immediate: true
        },
        // Observar cambios en el array completo
        apoyo: {
            handler() {
                this.verificarCampos_apoyo();
            },
            deep: true // Para detectar cambios en los objetos dentro del array
        },
        relator: {
            handler() {
                this.verificarCampos_relator();
            },
            deep: true // Para detectar cambios en los objetos dentro del array
        }
    },
    methods:{
        cargarEvento(codigo) {
            this.evento = codigo;
            axios.get(`/api/get_evento/${codigo}`).then(response => {
                if(response.data.estado){
                    this.eventoid_seleccion = response.data.evento;
                    this.cargarLaborantes();
                }
            });
        },
        cargarLaborantes() {
            axios.get(`/api/get_laborantes_evento/${this.eventoid_seleccion.codigo}`).then(response => {
                if(this.apoyo.length==0){
                    this.agregar_lab_apoyo();
                }
                if(this.relator.length==0){
                    this.agregar_lab_relator();
                }
                this.apoyo_pagado = response.data.apoyo_pagado || [];
                this.relator_pagado = response.data.relator_pagado || [];
            });
        },
        verificarCampos_apoyo() {
            this.apoyo.forEach((lab, index) => {
                if (lab.laborante && lab.hora_inicio && lab.hora_fin) {
                    const laborante_id = lab.laborante.id || lab.laborante_id;
                    if (!laborante_id) {
                        this.msg('error', 'Error: El laborante seleccionado no tiene ID.');
                        return;
                    }
                    const formData = new FormData();
                    formData.append('laborante_id', laborante_id);
                    formData.append('fecha', this.eventoid_seleccion.fecha_inicio);
                    formData.append('hora_inicio', lab.hora_inicio);
                    formData.append('hora_fin', lab.hora_fin);
                    axios.post('/api/revisar_choque_horario_laborante', formData).then(response => {
                        if (!response.data.estado) {
                            this.msg('error', 'El laborante ya tiene horas asignadas en este horario.');
                            console.log('El laborante ya tiene horas asignadas en este horario.');
                            lab.hora_inicio = '';
                            lab.hora_fin = '';
                        }
                    })
                    .catch(() => {
                        this.msg('error', 'Error al verificar choque de horario.');
                        console.log('Error al verificar choque de horario.');

                    });
                }
            });
        },
        verificarCampos_relator() {
            this.relator.forEach((lab, index) => {
                if (lab.laborante && lab.hora_inicio && lab.hora_fin) {
                    const laborante_id = lab.laborante.id || lab.laborante_id;
                    if (!laborante_id) {
                        this.msg('error', 'Error: El laborante seleccionado no tiene ID.');
                        return;
                    }
                    const formData = new FormData();
                    formData.append('laborante_id', laborante_id);
                    formData.append('fecha', this.eventoid_seleccion.fecha_inicio);
                    formData.append('hora_inicio', lab.hora_inicio);
                    formData.append('hora_fin', lab.hora_fin);
                    axios.post('/api/revisar_choque_horario_laborante', formData).then(response => {
                        if (!response.data.estado) {
                            this.msg('error', 'El laborante ya tiene horas asignadas en este horario.');
                            console.log('El laborante ya tiene horas asignadas en este horario.');
                            lab.hora_inicio = '';
                            lab.hora_fin = '';
                        }
                    })
                    .catch(() => {
                        this.msg('error', 'Error al verificar choque de horario.');
                        console.log('Error al verificar choque de horario.');

                    });
                }
            });
        },
        labelselect_laborante ({ name }) {
            return `${name}`
        },
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        agregar_lab_apoyo(){
            let a={
                laborante:[],
                hora_inicio:'',
                hora_fin:'',
            };
            this.apoyo.push(a);
        },
        eliminar_apoyo(index){
            this.apoyo.splice(index, 1);
        },
        guardar_apoyo(){
            if (this.apoyo.length==0) {
                this.msg('error','No hay laborantes para agregar');
                return
            }
            //elimino los laborantes vacios
            this.apoyo.forEach(element => {
                if((!element.laborante || (Array.isArray(element.laborante) && element.laborante.length===0)) && element.hora_inicio=='' && element.hora_fin==''){
                    var indice = this.apoyo.indexOf(element); // obtenemos el indice
                    this.apoyo.splice(indice, 1); // 1 es la cantidad de elemento a eliminar
                }
            });
            let formData = new FormData();
            formData.append('apoyo', JSON.stringify(this.apoyo));
            formData.append('evento_id', this.eventoid_seleccion.id);
            formData.append('fecha', this.eventoid_seleccion.fecha_inicio);
            axios.post('/api/guardar_laborantes_apoyo', formData).then(response => {
                this.actualizar()
                this.msg('success','Se han guardado los laborantes de apoyo.');
            }).catch(error => {
                const msg = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message : error.message;
                this.msg('error', 'Error al guardar: ' + msg);
            });

        },
        agregar_lab_relator(){
            let a={
                laborante:[],
                hora_inicio:'',
                hora_fin:'',
            };
            this.relator.push(a);
        },
        eliminar_relator(index){
            this.relator.splice(index, 1);
        },
        guardar_relator(){
            if (this.relator.length==0) {
                this.msg('error','No hay laborantes para agregar');
                return
            }
            //elimino los laborantes vacios
            this.relator.forEach(element => {
                if((!element.laborante || (Array.isArray(element.laborante) && element.laborante.length===0)) && element.hora_inicio=='' && element.hora_fin==''){
                    var indice = this.relator.indexOf(element); // obtenemos el indice
                    this.relator.splice(indice, 1); // 1 es la cantidad de elemento a eliminar
                }
            });
            let formData = new FormData();
            formData.append('relator', JSON.stringify(this.relator));
            formData.append('evento_id', this.eventoid_seleccion.id);
            formData.append('fecha', this.eventoid_seleccion.fecha_inicio);
            axios.post('/api/guardar_laborantes_relator', formData).then(response => {
                this.actualizar()
                this.msg('success','Se han guardado laborantes relator.');
            }).catch(error => {
                const msg = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message : error.message;
                this.msg('error', 'Error al guardar: ' + msg);
            });
        },
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY');
            return orden
        },
        obtenerLabotante(element){
            let laborante = this.laborantes.filter((us) => us.id==element);
            if (laborante.length>0) {
                return laborante[0];
            }
            return { name: 'Laborante no disponible', rut: '-' };
        },
        nombreLaborante(item) {
            return (item.laborante && item.laborante.name) || this.obtenerLabotante(item.laborante_id).name;
        },
        rutLaborante(item) {
            return (item.laborante && item.laborante.rut) || this.obtenerLabotante(item.laborante_id).rut;
        },
        actualizar(){
            axios.get(`/api/get_laborantes_evento/${this.eventoid_seleccion.codigo}`).then(response => {
                //this.apoyo= response.data.apoyo;
                this.relator=[];
                this.apoyo=[];
                if(this.apoyo.length==0){
                    this.agregar_lab_apoyo();
                }
                if(this.relator.length==0){
                    this.agregar_lab_relator();
                }
                this.apoyo_pagado = response.data.apoyo_pagado || [];
                this.relator_pagado = response.data.relator_pagado || [];
            });
        },
        valorpago(lab){
            axios.get('/api/get_pagos_periodo/'+lab.id).then(response => {
                this.liquido = response.data.total_liquido
                if (this.liquido>=250000) {
                    Swal.fire({
                        //position: "top-end",
                        icon: 'warning',
                        title: 'Laborante alcanzó limite de $250.000 en periodo '+this.formatFecha(response.data.inicio)+' al '+this.formatFecha(response.data.fin) ,
                        text: 'Tener en consideración para próximas actividades.',
                        confirmButtonText: "Aceptar"
                        //showConfirmButton: false,
                        //timer: 5000
                    });
                }
            });
        }
    },
    mounted(){
        axios.get('/api/get_laborantes').then(response => {
            if (this.user.rol=='Admin') {
                this.laborantes= response.data.usuarios;
            }else {
                this.laborantes= response.data.usuarios;
            }
        });
        axios.get('/api/get_tipos').then(res=>{
            this.tipos=res.data.tipos
            this.subtipos=res.data.subtipos
        });
    },
    created(){
        if (this.eventoCodigo) {
            this.cargarEvento(this.eventoCodigo);
            return;
        }
        if (localStorage.getItem("evento_codigo")) {
            const evento = localStorage.getItem("evento_codigo");
            this.evento = evento;
            localStorage.removeItem("evento_codigo");
            this.cargarEvento(evento);
            return;
        }
        if (this.allowRedirect) {
            window.location.href = "/web/configuracion/eventosiniciados";
        }
    }
};
</script>
<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card mt-3">
                <!-- Header UGM -->
                <div class="card-header py-3 d-flex align-items-center" style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                    <i class="bx bx-calendar-check font-size-24 text-white mr-2"></i>
                    <div>
                        <h5 class="text-white mb-0 font-weight-bold">Evento - Laborantes</h5>
                        <small class="text-white" style="opacity:.8;">Asigna laborantes al evento seleccionado</small>
                    </div>
                </div>

                <div class="card-body">

                    <!-- ── SECCIÓN: Laborantes de Apoyo ── -->
                    <div v-if="!readOnly" class="mb-1">
                        <p class="text-uppercase font-size-11 font-weight-bold mb-3" style="color:#252C5F; letter-spacing:.06em;">
                            <i class="mdi mdi-account-group mr-1"></i>Laborantes de Apoyo
                        </p>

                        <!-- Fila por laborante -->
                        <div v-for="(lab, index) in apoyo" :key="'apoyo-'+index" class="d-flex align-items-end flex-wrap mb-3 pb-3" style="gap:12px; border-bottom:1px solid #f0f2fa;">
                            <!-- Laborante -->
                            <div style="flex:2; min-width:200px;">
                                <label class="font-size-12 font-weight-semibold mb-1" style="color:#252C5F;">
                                    Laborante <span class="text-danger">*</span>
                                </label>
                                <multiselect
                                    v-model="lab.laborante"
                                    :options="laborantes"
                                    placeholder="Seleccionar laborante"
                                    selectLabel="Presiona para seleccionar"
                                    selectedLabel="Seleccionado"
                                    deselectLabel="Presiona para remover"
                                    :custom-label="labelselect_laborante"
                                    @select="valorpago"
                                >
                                    <template v-slot:noOptions><p class="mb-0">Sin opciones</p></template>
                                    <template v-slot:noResult><p class="mb-0">Sin coincidencias</p></template>
                                </multiselect>
                            </div>
                            <!-- Hora inicio -->
                            <div style="flex:1; min-width:130px;">
                                <label class="font-size-12 font-weight-semibold mb-1" style="color:#252C5F;">
                                    Hora Inicio <span class="text-danger">*</span>
                                </label>
                                <date-picker v-model="lab.hora_inicio" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" style="width:100%;"></date-picker>
                            </div>
                            <!-- Hora fin -->
                            <div style="flex:1; min-width:130px;">
                                <label class="font-size-12 font-weight-semibold mb-1" style="color:#252C5F;">
                                    Hora Fin <span class="text-danger">*</span>
                                </label>
                                <date-picker v-model="lab.hora_fin" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" style="width:100%;"></date-picker>
                            </div>
                            <!-- Eliminar -->
                            <div>
                                <button class="btn btn-ugm-danger" @click="eliminar_apoyo(index)" title="Eliminar">
                                    <i class="bx bx-trash"></i>
                                </button>
                            </div>
                        </div>

                        <!-- Acciones -->
                        <div class="d-flex justify-content-between align-items-center mt-2 mb-3">
                            <button class="btn btn-ugm-white" @click="agregar_lab_apoyo">
                                <i class="mdi mdi-plus mr-1"></i>+ Laborante
                            </button>
                            <button class="btn btn-ugm-dark" @click="guardar_apoyo()">
                                <i class="mdi mdi-content-save mr-1"></i>Guardar Laborantes de Apoyo
                            </button>
                        </div>
                    </div>

                    <!-- ── SECCIÓN: Relator (toggle) ── -->
                    <div v-if="false && !readOnly" class="mb-3 pt-3" style="border-top:1px solid #e9ecef;">
                        <div class="d-flex align-items-center" style="gap:10px;">
                            <b-form-checkbox id="checkbox-1" v-model="status" name="checkbox-1" />
                            <label for="checkbox-1" class="mb-0 font-size-13 font-weight-semibold" style="color:#252C5F; cursor:pointer;">
                                <i class="mdi mdi-microphone mr-1"></i>Relator
                            </label>
                        </div>
                    </div>

                    <div v-if="false && status && !readOnly">
                        <p class="text-uppercase font-size-11 font-weight-bold mb-3" style="color:#252C5F; letter-spacing:.06em;">
                            <i class="mdi mdi-microphone mr-1"></i>Relator(es)
                        </p>

                        <div v-for="(lab, index) in relator" :key="'relator-'+index" class="d-flex align-items-end flex-wrap mb-3 pb-3" style="gap:12px; border-bottom:1px solid #f0f2fa;">
                            <div style="flex:2; min-width:200px;">
                                <label class="font-size-12 font-weight-semibold mb-1" style="color:#252C5F;">
                                    Laborante <span class="text-danger">*</span>
                                </label>
                                <multiselect
                                    v-model="lab.laborante"
                                    :options="laborantes"
                                    placeholder="Seleccionar laborante"
                                    selectLabel="Presiona para seleccionar"
                                    selectedLabel="Seleccionado"
                                    deselectLabel="Presiona para remover"
                                    :custom-label="labelselect_laborante"
                                >
                                    <template v-slot:noOptions><p class="mb-0">Sin opciones</p></template>
                                    <template v-slot:noResult><p class="mb-0">Sin coincidencias</p></template>
                                </multiselect>
                            </div>
                            <div style="flex:1; min-width:130px;">
                                <label class="font-size-12 font-weight-semibold mb-1" style="color:#252C5F;">
                                    Hora Inicio <span class="text-danger">*</span>
                                </label>
                                <date-picker v-model="lab.hora_inicio" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" style="width:100%;"></date-picker>
                            </div>
                            <div style="flex:1; min-width:130px;">
                                <label class="font-size-12 font-weight-semibold mb-1" style="color:#252C5F;">
                                    Hora Fin <span class="text-danger">*</span>
                                </label>
                                <date-picker v-model="lab.hora_fin" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" style="width:100%;"></date-picker>
                            </div>
                            <div>
                                <button class="btn btn-ugm-danger" @click="eliminar_relator(index)" title="Eliminar">
                                    <i class="bx bx-trash"></i>
                                </button>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center mt-2 mb-3">
                            <button class="btn btn-ugm-white" @click="agregar_lab_relator">
                                <i class="mdi mdi-plus mr-1"></i>+ Laborante
                            </button>
                            <button class="btn btn-ugm-dark" @click="guardar_relator()">
                                <i class="mdi mdi-content-save mr-1"></i>Guardar Relator(es)
                            </button>
                        </div>
                    </div>

                    <!-- ── SECCIÓN: Laborantes ya agregados ── -->
                    <div v-if="tieneLaborantesAsignados" class="mt-3 pt-3" style="border-top:1px solid #e9ecef;">
                        <p class="text-uppercase font-size-11 font-weight-bold mb-3" style="color:#252C5F; letter-spacing:.06em;">
                            <i class="mdi mdi-check-circle mr-1" style="color:#CB9700;"></i>Laborantes ya agregados
                        </p>
                        <div class="table-responsive">
                            <table class="table table-hover mb-0">
                                <thead>
                                    <tr style="background:#252C5F;">
                                        <th class="text-white font-size-12">Nombre</th>
                                        <th class="text-white font-size-12">RUT</th>
                                        <th class="text-white font-size-12">Tipo</th>
                                        <th class="text-white font-size-12">Fecha</th>
                                        <th class="text-white font-size-12">Hora inicio</th>
                                        <th class="text-white font-size-12">Hora fin</th>
                                        <th class="text-white font-size-12">Comentario</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in apoyo_pagado" :key="'ap-'+index">
                                        <td>{{ nombreLaborante(item) }}</td>
                                        <td>{{ rutLaborante(item) }}</td>
                                        <td><span class="badge" style="background:#61B7E4; color:#fff;">{{ item.tipo_laborante }}</span></td>
                                        <td>{{ formatFecha(item.fecha) }}</td>
                                        <td>{{ item.hora_inicio }}</td>
                                        <td>{{ item.hora_fin }}</td>
                                        <td>{{ item.comentario || '-' }}</td>
                                    </tr>
                                    <tr v-for="(item, index) in relator_pagado" :key="'rel-'+index">
                                        <td>{{ nombreLaborante(item) }}</td>
                                        <td>{{ rutLaborante(item) }}</td>
                                        <td><span class="badge" style="background:#252C5F; color:#fff;">{{ item.tipo_laborante }}</span></td>
                                        <td>{{ formatFecha(item.fecha) }}</td>
                                        <td>{{ item.hora_inicio }}</td>
                                        <td>{{ item.hora_fin }}</td>
                                        <td>{{ item.comentario || '-' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div v-else class="text-center text-muted py-4" style="border:1px dashed #dee2e6;border-radius:8px;">
                        <i class="mdi mdi-account-group font-size-24 d-block mb-2" style="color:#CB9700;"></i>
                        No hay laborantes registrados para este evento.
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.btn-ugm-dark {
    background-color: #252C5F; color:#fff; border:none;
    border-radius:6px; padding:7px 16px; font-size:13px; font-weight:600; transition:background .2s;
}
.btn-ugm-dark:hover { background-color:#1a1f44; color:#fff; }
.btn-ugm-white {
    background-color:#fff; color:#252C5F; border:1.5px solid #252C5F;
    border-radius:6px; padding:7px 16px; font-size:13px; font-weight:600; transition:background .2s;
}
.btn-ugm-white:hover { background-color:#f0f2fa; color:#252C5F; }
.btn-ugm-danger {
    background-color:#e74c3c; color:#fff; border:none;
    border-radius:6px; padding:7px 12px; font-size:13px; font-weight:600; transition:background .2s;
}
.btn-ugm-danger:hover { background-color:#c0392b; color:#fff; }
</style>
                        <div class="row">
                            <!-- <div class="col-md-12 mb-3">
                                <h1 class="text-primary mb-4">{{ eventoid_seleccion.nombre_difusion }}</h1>
                                <h3 class="text-primary mb-4">{{ eventoid_seleccion.colegio }}</h3>
                            </div>
                            <div class="col-md-6">
                                <p class="font-size-16"><strong>Actividad:</strong> {{ eventoid_seleccion.nombre_difusion }}</p>
                                <p class="font-size-16"><strong>Código:</strong> {{ eventoid_seleccion.codigo }}</p>
                                <p class="font-size-16"><strong>Fecha Inicio:</strong> {{ eventoid_seleccion.fecha_inicio }}</p>
                                <p class="font-size-16"><strong>Fecha de término:</strong> {{ eventoid_seleccion.fecha_termino }}</p>
                                <p class="font-size-16"><strong>Tipo:</strong> {{ tipos.find((us)=> us.codigo==eventoid_seleccion.tipo_codigo).nombre }}</p>
                                <p class="font-size-16"><strong>SubTipo:</strong> {{ subtipos.find((us)=> us.codigo==eventoid_seleccion.subtipo_codigo).nombre }}</p>
                            </div>
                            <div class="col-md-6">
                                <p class="font-size-16"><strong>Nombre para Difusión Digital:</strong> {{ eventoid_seleccion.nombre_difusion }}</p>
                                <p class="font-size-16"><strong>Cantidad Inscripciones:</strong> {{ eventoid_seleccion.cantidad_inscripciones }}</p>
                                <p class="font-size-16"><strong>Nº Asistentes:</strong> {{ eventoid_seleccion.num_asistentes }}</p>
                                <p class="font-size-16"><strong>Responsable:</strong> {{ eventoid_seleccion.propietario }}</p>

                            </div> -->
                            <div class="offset-md-1 col-md-10 shadow-sm">
                                <h5 class="text-primary mb-4">Agregar Laborantes Apoyo: </h5>
                                <div class="row" v-for="(lab,index) in apoyo" :key="index">
                                    <div class="col-md-4">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Laborante:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <multiselect
                                                    v-model="lab.laborante"
                                                    :options="laborantes"
                                                    placeholder="Seleccionar laborante"
                                                    selectLabel="Presiona para seleccionar"
                                                    selectedLabel="Seleccionado"
                                                    deselectLabel="Presiona para remover"
                                                    :custom-label="labelselect_laborante"
                                                    @select="valorpago"
                                                    >
                                                    <template v-slot:noOptions>
                                                        <p>No hay opciones</p>
                                                    </template>
                                                    <template v-slot:noResult>
                                                        <p>No se encuentra coincidencia</p>
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Hora inicio:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <date-picker v-model="lab.hora_inicio" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" ></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Hora fin:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <date-picker v-model="lab.hora_fin" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" ></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-1">
                                        <br>
                                        <b-button variant="danger" class="mt-2" @click="eliminar_apoyo(index)"><i class="bx bx-trash"></i></b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="offset-md-6 col-md-6 text-right mb-3">
                                        <b-button class="" variant="primary" @click="agregar_lab_apoyo"><i class="bx bx-plus"></i>Laborante</b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 mb-3">
                                        <b-button variant="primary" block @click="guardar_apoyo()">Guardar Laborantes de Apoyo</b-button>
                                    </div>
                                </div>
                            </div>

                            <div class="offset-md-1 col-md-10">
                                <div class="row">
                                    <div class="col-md-6 mt-4">
                                        <b-form-checkbox id="checkbox-1" v-model="status" name="checkbox-1" > Relator </b-form-checkbox>
                                    </div>
                                </div>
                            </div>
                            <div class="offset-md-1 col-md-10 mt-3 shadow-sm" v-if="status">
                                <h5 class="text-primary mb-4">Agregar Relator: </h5>
                                <div class="row" v-for="(lab,index) in relator" :key="index">
                                    <div class="col-md-4">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Laborante:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <multiselect
                                                    v-model="lab.laborante"
                                                    :options="laborantes"
                                                    placeholder="Seleccionar laborante"
                                                    selectLabel="Presiona para seleccionar"
                                                    selectedLabel="Seleccionado"
                                                    deselectLabel="Presiona para remover"
                                                    :custom-label="labelselect_laborante"
                                                    >
                                                    <template v-slot:noOptions>
                                                        <p>No hay opciones</p>
                                                    </template>
                                                    <template v-slot:noResult>
                                                        <p>No se encuentra coincidencia</p>
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Hora inicio:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <date-picker v-model="lab.hora_inicio" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" ></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group row">
                                            <div class="col-md-6">
                                                <label for="pais"> Hora fin:</label>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <label for="pais" class="text-primary"> * Obligatorio</label>
                                            </div>
                                            <div class="col-md-12">
                                                <date-picker v-model="lab.hora_fin" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" ></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-1">
                                        <br>
                                        <b-button variant="danger" class="mt-2" @click="eliminar_relator(index)"><i class="bx bx-trash"></i></b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="offset-md-6 col-md-6 text-right mb-3">
                                        <b-button class="" variant="primary" @click="agregar_lab_relator"><i class="bx bx-plus"></i>Laborante</b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 mb-3">
                                        <b-button variant="primary" block @click="guardar_relator()">Guardar Relator(es)</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3" v-if="apoyo_pagado.length>0 || relator_pagado.length>0">
                            <div class="col-md-12">
                                <h5 class="text-primary mb-4">Laborantes ya agregados</h5>
                                <div class="table-responsive mb-0 mt-3">
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                                <th style="width: 20%;">Nombre</th>
                                                <th style="width: 10%;">RUT</th>
                                                <th style="width: 10%;">Tipo</th>
                                                <th style="width: 10%;">Fecha trabajada</th>
                                                <th style="width: 10%;">Fecha de ingreso</th>
                                                <th style="width: 10%;">Hora inicio</th>
                                                <th style="width: 10%;">Hora fin</th>
                                                <!-- <th style="width: 20%;">Acción</th> -->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in apoyo_pagado" :key="index">
                                                <td>{{ obtenerLabotante(item.laborante_id).name }}</td>
                                                <td>{{ obtenerLabotante(item.laborante_id).rut }}</td>
                                                <td>{{ item.tipo_laborante }}</td>
                                                <td>{{ formatFecha(item.fecha) }}</td>
                                                <td>{{ formatFecha(item.fecha_ingreso) }}</td>
                                                <td>{{ item.hora_inicio }}</td>
                                                <td>{{ item.hora_fin }}</td>
                                                <!-- <td>

                                                </td> -->
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr v-for="(item, index) in relator_pagado" :key="index">
                                                <td>{{ obtenerLabotante(item.laborante_id).name }}</td>
                                                <td>{{ obtenerLabotante(item.laborante_id).rut }}</td>
                                                <td>{{ item.tipo_laborante }}</td>
                                                <td>{{ formatFecha(item.fecha) }}</td>
                                                <td>{{ formatFecha(item.fecha_ingreso) }}</td>
                                                <td>{{ item.hora_inicio }}</td>
                                                <td>{{ item.hora_fin }}</td>
                                                <!-- <td>

                                                </td> -->
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <!-- </Layout> -->
</template>
